export const createButtonTheme = (backgroundColor, borderColor, textColor, backgroundColorHover, borderColorHover, textColorHover) => ({
    backgroundColor,
    borderColor,
    textColor,
    backgroundColorHover,
    borderColorHover,
    textColorHover,
});
